var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRingtone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2391 11C15.2391 8.86606 14.053 8.07952 13.0869 7.86602V7.60001C13.0869 6.8 11.9131 6.8 11.9131 7.60001V7.86602C10.947 8.07952 9.76091 8.86606 9.76091 11C9.76091 14.5999 8 13.6 8 16.1999C8 17.5999 10.7391 18 12.5 18C14.2609 18 17 17.6001 17 16.1999C17 13.6 15.2391 14.6001 15.2391 11ZM12.5 17.4C10.9348 17.4 8.58693 17.0001 8.58693 16.2001C8.58693 15.4001 10.9348 15.0001 12.5 15.0001C12.6645 15.0001 12.8377 15.0046 13.0157 15.0135C12.9354 15.1323 12.8912 15.2663 12.8912 15.4002C12.8912 16.0002 13.2825 16.4002 13.8695 16.4002C14.2608 16.4002 14.6522 16.0003 14.6522 15.4002C14.6522 15.3347 14.6415 15.2692 14.6223 15.2056C15.6057 15.3996 16.4131 15.7311 16.4131 16.2002C16.4131 17.0001 14.0652 17.4 12.5 17.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRingtone);
export default __webpack_public_path__ + "static/media/icon-ringtone.2ce29116d67c3cfd6174fb5551516436.svg";
export { ForwardRef as ReactComponent };